/* SETTINGS */
export const CHANGE_LOCALE = "CHANGE_LOCALE";

export * from "./settings/actions";
export * from "./compApproverData/actions";

